<template>
  <div class="task-score-container">
    <div class="table-panel  mb10 ">
      <div class="flex flex-between item-center">
        <div class="form-wrapper flex flex-1 flex-wrap flex-end ">
          <el-cascader
            clearable
            v-model="columnId"
            :options="options"
            size="small"
            :props="{ checkStrictly: true }"
            :show-all-levels="false"
            class="mr10"
            placeholder="请选择分类"
          ></el-cascader>
          <el-cascader
            clearable
            ref="cascader"
            v-model="selectedStore"
            :props="props"
            :show-all-levels="false"
            size="small"
            placeholder="请选择机构"
            class="mr10"
          ></el-cascader>
          <el-select
            size="small"
            clearable
            filterable
            placeholder="请选择被考核人"
            v-model="searchConditons.employeeId"
            style="width: 150px"
            class="mr10"
          >
            <el-option
              v-for="(item, index) in employeeList"
              :key="index"
              :label="item.realname"
              :value="item.employeeId"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            clearable
            filterable
            placeholder="请选择考核组"
            v-model="searchConditons.groupId"
            style="width: 150px"
            class="mr10"
          >
            <el-option
              v-for="(item, index) in groupList"
              :key="index"
              :label="item.groupName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            clearable
            filterable
            placeholder="请选择考核等级"
            v-model="searchConditons.levelPointId"
            style="width: 150px"
            class="mr10"
          >
            <el-option
              v-for="(item, index) in levelList"
              :key="index"
              :label="item.pointName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
          <el-button type="success" size="small" @click="outputExcel"
            >导出列表</el-button
          >
          <!-- v-if="confirmStatus === 'confirmed'" -->
          <el-button size="small" type="info">
            <div class=" open-file pointer">
              批量导入分数
              <input
                type="file"
                class="pointer"
                @change="importf"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel "
              />
            </div>
          </el-button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="flex flex-between item-center">
        <div class="caption flex item-center mb20 bold">{{ taskName }}</div>
        <div class="flex item-center">
          <div class="mr20 batch pointer flex item-center" @click="batchRating">
            <span class="hmicon icon-piliangpingfen"></span>
            <span>批量评分</span>
          </div>
          <div
            class="batch pointer flex item-center"
            @click="batchConfirm('batch')"
          >
            <span class="hmicon icon-piliangqueren"></span>
            <span>批量确认</span>
          </div>
        </div>
      </div>
      <div class="table mb20">
        <el-table
          @selection-change="getChecked"
          stripe
          border
          :data="list"
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            width="50"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <template v-for="(item, index) in tableHeader">
            <el-table-column
              header-align="center"
              :key="index"
              align="center"
              :fixed="item.isFixed === 'yes'"
              :prop="item.name"
              :label="item.name"
            >
              <template slot-scope="scope">
                <div
                  :class="[
                    {
                      autoColor:
                        scope.row[scope.column.property].reltype === 'auto' ||
                        scope.row[scope.column.property].scoreType ===
                          'autoScore'
                    },
                    {
                      manualColor:
                        scope.row[scope.column.property].reltype === 'manual' ||
                        scope.row[scope.column.property].scoreType ===
                          'manualScore'
                    },
                    {
                      success:
                        scope.row[scope.column.property].scoreType ===
                        'totalScore'
                    }
                  ]"
                >
                  <template
                    v-if="
                      scope.row[scope.column.property].isScore === 'yes' &&
                        scope.row[scope.column.property].canEdit
                    "
                  >
                    <el-input
                      style="width: 60px"
                      class="text-center"
                      @mousewheel.native.prevent
                      type="number"
                      v-model="scope.row[scope.column.property].columnValue"
                    ></el-input>
                  </template>
                  <template v-else>
                    <template
                      v-if="
                        scope.row[scope.column.property].columnValue ===
                          'confirmed'
                      "
                    >
                      <span class="success">已确认</span>
                    </template>
                    <template
                      v-if="
                        scope.row[scope.column.property].columnValue ===
                          'toConfirmed'
                      "
                    >
                      <span class="danger">待确认</span>
                    </template>
                    <span v-else>{{
                      scope.row[scope.column.property].columnValue
                    }}</span>
                  </template>
                </div>
              </template>
            </el-table-column>
          </template>
          <!-- v-if="confirmStatus !== 'inProgress'" -->
          <el-table-column
            fixed="right"
            header-align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="text"
                class="bule"
                v-if="!scope.row.canEdit && !scope.row.disabled"
                @click="editScore(scope.row, scope.$index)"
              >
                编辑
              </el-button>
              <el-button
                v-if="scope.row.canEdit && !scope.row.disabled"
                size="small"
                type="text"
                class="bule"
                @click="saveScore(scope.row, scope.$index)"
              >
                保存
              </el-button>
              <el-button
                size="small"
                v-if="!scope.row.disabled"
                type="text"
                class="bule"
                @click="batchConfirm('single', scope.row)"
              >
                确认评分
              </el-button>
              <el-button
                size="small"
                type="text"
                class="bule"
                @click="viewDetails(scope.row)"
              >
                操作记录
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          ref="pagination"
        ></el-pagination>
      </div>
    </div>
    <!-- 批量评分 -->
    <el-dialog
      width="500px"
      title="批量评分"
      :visible.sync="batchRatingDialogVisible"
    >
      <div>
        <el-form
          label-width="80px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="评分类型" prop="columnIdList">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <el-checkbox-group
              @change="handleSingleChange('ruleForm')"
              v-model="ruleForm.columnIdList"
            >
              <el-checkbox
                :label="v.columnId"
                v-for="(v, i) in fieldList"
                :key="i"
                >{{ v.columnName }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="分值" prop="scoreValue">
            <el-input
              size="small"
              type="number"
              v-model="ruleForm.scoreValue"
              placeholder="请输入分值"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="flex flex-center">
          <el-button
            type="primary"
            size="small"
            @click="saveBatch('ruleForm', 'isScore')"
            >保存</el-button
          >
          <el-button size="small" @click="batchRatingDialogVisible = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 批量确认 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="batchConfirmDialogVisible"
      width="500px"
    >
      <div>
        <el-form
          label-width="80px"
          :model="confirmRuleForm"
          :rules="confirmRules"
          ref="confirmRuleForm"
        >
          <el-form-item label="确认评分" prop="columnIdList">
            <el-checkbox
              v-model="confirmCheckAll"
              @change="handleConfirmCheckAllChange"
              >全选</el-checkbox
            >
            <el-checkbox-group
              @change="handleConfirmSingleChange('confirmRuleForm')"
              v-model="confirmRuleForm.columnIdList"
            >
              <el-checkbox
                :label="v.columnId"
                v-for="(v, i) in fieldList"
                :key="i"
                >{{ v.columnName }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div class="flex flex-center">
          <el-button
            type="primary"
            size="small"
            @click="saveBatch('confirmRuleForm', 'isConfirm')"
            >保存</el-button
          >
          <el-button size="small" @click="batchConfirmDialogVisible = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 操作记录 -->
    <el-dialog width="1000px" title="操作记录" :visible.sync="dialogVisible">
      <div class="flex flex-end mb20">
        <el-select
          size="small"
          clearable
          filterable
          placeholder="请选择操作项目"
          v-model="searchLogColumnId"
          style="width: 150px"
          class="mr10"
        >
          <el-option
            v-for="(item, index) in fieldList"
            :key="index"
            :label="item.columnName"
            :value="item.columnId"
          ></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="searchLog"
          >查询</el-button
        >
      </div>
      <el-table style="height: 600px" stripe border :data="logList">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          width="50"
          label="序号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="columnName"
          label="操作项目"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="remarks"
          label="操作结果"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="操作人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="操作时间"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  data() {
    return {
      columnId: "",
      options: [],
      logList: [],
      fieldList: [],
      ruleForm: {
        scoreValue: "",
        columnIdList: []
      },
      rules: {
        scoreValue: {
          required: true,
          message: "请输入分值",
          trigger: "blur"
        },
        columnIdList: {
          required: true,
          message: "请确认评分类型",
          trigger: "change"
        }
      },
      checkAll: false,
      confirmCheckAll: false,
      confirmRuleForm: {
        columnIdList: []
      },
      confirmRules: {
        columnIdList: {
          required: true,
          message: "请确认评分类型",
          trigger: "change"
        }
      },
      batchRatingDialogVisible: false,
      searchConditons: {
        taskStatusDesc: "all",
        employeeId: "",
        keyword: "",
        levelPointId: "",
        groupId: "",
        memberType: "member"
      },
      taskName: "",
      confirmStatus: "",
      list: [],
      total: 0,
      currentEmplyeeId: "",
      taskId: "",
      currentPage: 1,
      pageSize: 10,
      selectedStore: [],
      couponLevelList: [],
      storeList: [],
      groupList: [],
      levelList: [],
      tableHeader: [],
      checkedList: [],
      dialogTitle: "确认评分",
      batchConfirmDialogVisible: false,
      dialogVisible: false,
      employeeList: [],
      searchLogColumnId: "",
      currentConfirmRow: null,
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: async (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            const res = await this.$store.dispatch("queryOrganizationTree", {
              pageNo: 1,
              pageSize: 999,
              loginType: "store"
            });
            res.result.records.forEach(v => {
              v.leaf = Boolean(!v.isParent);
              v.value = v.orgCode;
              v.label = v.departName;
            });
            resolve(res.result.records);
          } else {
            const res = await this.$store.dispatch(
              "queryOrganizationListByParent",
              {
                parentId: data.treeStruct
              }
            );
            if (res.code === "0" && res.result) {
              res.result.forEach(v => {
                v.leaf = Boolean(!v.isParent);
                v.value = v.orgCode;
                v.label = v.departName;
              });
              resolve(res.result);
            } else {
              resolve([]);
            }
          }
        }
      }
    };
  },
  created() {
    this.taskId = this.$route.query.taskId;
    this.taskName = this.$route.query.taskName;
    this.confirmStatus = this.$route.query.confirmStatus;
  },
  async mounted() {
    await this.queryTableHeader();
    await this.queryList();
    this.queryStoreList();
    this.queryEmployee();
    this.queryGroupList();
    this.queryLevelList();
    this.queryTaskFieldList();
    this.queryScoreFilterField();
  },
  computed: mapGetters([]),
  watch: {},
  methods: {
    async queryScoreFilterField() {
      const { result } = await this.$store.dispatch("queryScoreFilterField", {
        taskId: this.taskId
      });
      let autoChildren = [];
      let manualChildren = [];
      manualChildren = result.manual.map(v => {
        return {
          label: v.columnName,
          value: v.columnId
        };
      });
      autoChildren = result.auto.map(v => {
        return {
          label: v.columnName,
          value: v.columnId
        };
      });
      let options = [
        {
          value: "",
          label: "全部",
          children: [
            {
              value: "auto",
              label: "自动",
              children: autoChildren
            },
            {
              value: "manual",
              label: "手动",
              children: manualChildren
            }
          ]
        }
      ];
      this.options = options;
    },
    async queryTaskFieldList() {
      const { result } = await this.$store.dispatch("queryTaskFieldList", {
        taskId: this.taskId
      });
      this.fieldList = result;
    },
    async queryTableHeader() {
      const { result } = await this.$store.dispatch(
        "queryEmployeeScoreTableHeader",
        {
          taskId: this.taskId
        }
      );
      this.tableHeader = result;
    },
    async queryList(type) {
      const orgCode =
        this.selectedStore && this.selectedStore.length
          ? this.selectedStore[this.selectedStore.length - 1]
          : "";
      const columnId =
        this.columnId && this.columnId.length
          ? this.columnId[this.columnId.length - 1]
          : "";
      const params = {
        pageNo: type === "output" ? 1 : this.currentPage,
        pageSize: type === "output" ? 9999 : this.pageSize,
        orgCode,
        columnId,
        taskId: this.$route.query.taskId
      };
      Object.assign(params, this.searchConditons);
      const { result } = await this.$store.dispatch(
        "queryEmployeeScoreList",
        params
      );
      const { records, total } = result;
      records.forEach(v => {
        v.canEdit = false;
        for (let key in v) {
          if (v[key].columnValue === "confirmed") {
            v.disabled = true;
          }
        }
      });
      if (type === "output") {
        return records;
      }
      this.list = records;
      this.total = total;
    },
    async queryGroupList() {
      const { result } = await this.$store.dispatch(
        "queryExamineGroupListById",
        {
          id: this.$route.query.taskId
        }
      );
      this.groupList = result;
    },
    async queryLevelList() {
      const { result } = await this.$store.dispatch("queryExamineLevelById", {
        id: this.$route.query.taskId
      });
      this.levelList = result;
    },
    async queryStoreList() {
      let params = {
        pageSize: 99999,
        pageNo: 1
      };
      const { result } = await this.$store.dispatch("queryShopList", params);
      this.storeList = result.records;
    },
    async queryEmployee() {
      const { result } = await this.$store.dispatch("queryEmployee", {
        pageNo: 1,
        pageSize: 9999,
        loginType: "store",
        workingState: "yes"
      });
      this.employeeList = result.records;
    },
    switchTab(e) {
      this.activeTab = e;
      this.currentPage = 1;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    getChecked(checked) {
      this.checkedList = checked;
    },
    async batchConfirm(type, row) {
      this.confirmCheckAll = false;
      switch (type) {
        case "batch":
          this.currentConfirmRow = null;
          this.dialogTitle = "批量确认评分";
          if (!this.checkedList.length) {
            this.$message({
              type: "warning",
              message: "请选择被考核人"
            });
            return;
          }
          break;
        case "single":
          this.currentConfirmRow = row;
          this.dialogTitle = "确认评分";
          break;
        default:
          break;
      }
      this.batchConfirmDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.confirmRuleForm.resetFields();
      });
    },
    batchRating() {
      if (!this.checkedList.length) {
        this.$message({
          type: "warning",
          message: "请选择被考核人"
        });
        return;
      }
      this.checkAll = false;
      this.batchRatingDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields();
      });
    },
    editScore(row, index) {
      this.list.forEach((v, i) => {
        for (let key in v) {
          if (typeof v[key] !== "boolean") {
            v[key].canEdit = false;
          }
        }
      });
      this.list.forEach((v, i) => {
        for (let key in row) {
          for (let vkey in v) {
            if (key === vkey && v[vkey].isScore === "yes" && index === i) {
              if (index === i) {
                v[vkey].canEdit = true;
              } else {
                v[vkey].canEdit = false;
              }
            }
          }
        }
        if (index === i) {
          v.canEdit = true;
        } else {
          v.canEdit = false;
        }
      });
      this.$forceUpdate();
    },
    async saveScore(row) {
      let scoreList = [];
      for (let key in row) {
        if (row[key].isScore === "yes") {
          scoreList.push({
            id: row[key].columnKey,
            scoreValue: row[key].columnValue
          });
        }
      }
      await this.$store.dispatch("saveRowRating", {
        scoreList
      });
      this.$message({
        type: "success",
        message: "操作成功"
      });
      this.queryList();
    },
    async searchLog() {
      const { result } = await this.$store.dispatch("queryRatingLog", {
        emplyeeId: this.currentEmplyeeId,
        taskId: this.taskId,
        columnIdList: [this.searchLogColumnId]
      });
      this.logList = result;
    },
    async viewDetails(row) {
      this.dialogVisible = true;
      let emplyeeId = "";
      let columnIdList = [];
      for (let key in row) {
        if (row[key].isScore === "yes") {
          columnIdList.push(row[key].columnId);
          emplyeeId = row[key].emplyeeId;
        }
      }
      this.currentEmplyeeId = emplyeeId;
      const { result } = await this.$store.dispatch("queryRatingLog", {
        emplyeeId,
        taskId: this.taskId,
        columnIdList
      });
      this.logList = result;
    },
    handleCheckAllChange(value) {
      this.ruleForm.columnIdList = value
        ? this.fieldList.map(v => v.columnId)
        : [];
      this.checkAll = value;
    },
    handleSingleChange() {
      this.checkAll =
        this.ruleForm.columnIdList.length === this.fieldList.length;
    },
    handleConfirmCheckAllChange(value) {
      this.confirmRuleForm.columnIdList = value
        ? this.fieldList.map(v => v.columnId)
        : [];
      this.confirmCheckAll = value;
    },
    handleConfirmSingleChange() {
      this.confirmCheckAll =
        this.confirmRuleForm.columnIdList.length === this.fieldList.length;
    },
    // 确认评分
    async saveBatch(ruleFormType, confirmType) {
      let emplyeeIdList = [];
      if (this.currentConfirmRow) {
        const key = Object.keys(this.currentConfirmRow)[0];
        emplyeeIdList = [this.currentConfirmRow[key].emplyeeId];
      } else {
        this.checkedList.map(v => {
          const key = Object.keys(v)[0];
          emplyeeIdList.push(v[key].emplyeeId);
        });
      }
      const valid = await this.$refs[ruleFormType].validate();
      if (valid) {
        let params = {
          emplyeeIdList,
          columnIdList:
            confirmType === "isScore"
              ? this.ruleForm.columnIdList
              : this.confirmRuleForm.columnIdList,
          confirmType,
          taskId: this.taskId
        };
        if (confirmType === "isScore") {
          Object.assign(params, {
            scoreValue: this.ruleForm.scoreValue
          });
        }
        await this.$store.dispatch("batchUpdateRating", params);
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryList();
        this.batchConfirmDialogVisible = false;
      }
    },
    outputExcel() {
      require.ensure([], async () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = this.tableHeader
          .map(v => v.name)
          .concat("emplyeeId")
          .concat("taskId");
        const filterVal = tHeader;
        const list = [];
        const tableData = await this.queryList("output");
        tableData.map((v, i) => {
          const row = {};
          tHeader.map(o => {
            for (let key in v) {
              if (key === o) {
                row[key] = v[key].columnValue;
              }
              row.taskId = this.taskId;
              if (v[key].emplyeeId) {
                row.emplyeeId = v[key].emplyeeId;
              }
            }
          });
          list.push(row);
        });
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(
          tHeader,
          data,
          "绩效考核" + new Date().toLocaleTimeString()
        );
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = e => {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        let tableHeader = [];
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            tableHeader = roa.slice(0, 1)[0];
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        result.map(v => {
          let row = {};
          tableHeader.map((o, oi) => {
            row[o] = v[oi] || null;
          });
          formatResult.push(row);
        });
        this.$store.dispatch("importRatingFile", {
          jsonStr: JSON.stringify(formatResult)
        });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },

    // 过滤大于0且如果是小数保留两位
    filterGtrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[prop] = this[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (this[prop].indexOf(".") < 0 && this[prop] != "") {
        //首位是0的话去掉
        this[prop] = parseFloat(this[prop]);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.table-panel {
  background: #fff;
  padding: 15px;
}

.card {
  background: #fff;
  padding: 15px;
}

.caption {
  font-size: 16px;
  color: #222;
  &::before {
    content: "";
    width: 4px;
    height: 16px;
    border-radius: 2px 0px 2px 0px;
    background: #e50065;
    margin-right: 5px;
  }
}

.batch {
  color: #222;
  font-size: 14px;
  .hmicon {
    margin-right: 7px;
    font-size: 20px;
  }
}

.manualColor {
  color: #7440f6;
}

.autoColor {
  color: #00cecc;
}
</style>
